import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Github, Twitter, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-border bg-card" data-id="element-35">
      <div className="container mx-auto px-6 py-12 md:py-16" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-37">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-38">
            <div className="flex items-center gap-2" data-id="element-39">
              <div className="bg-primary p-1.5 rounded-lg" data-id="element-40">
                <Wrench className="h-5 w-5 text-primary-foreground" data-id="element-41" />
              </div>
              <span className="font-heading font-bold text-lg tracking-tight" data-id="element-42">
                GarageFlow
              </span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs" data-id="element-43">
              O ERP definitivo para oficinas mecânicas modernas. Simplifique sua
              gestão e foque no que importa.
            </p>
            <div className="flex items-center gap-4 text-muted-foreground" data-id="element-44">
              <a href="#" className="hover:text-foreground transition-colors" data-id="element-45">
                <Twitter className="h-5 w-5" data-id="element-46" />
              </a>
              <a href="#" className="hover:text-foreground transition-colors" data-id="element-47">
                <Github className="h-5 w-5" data-id="element-48" />
              </a>
              <a href="#" className="hover:text-foreground transition-colors" data-id="element-49">
                <Linkedin className="h-5 w-5" data-id="element-50" />
              </a>
              <a href="#" className="hover:text-foreground transition-colors" data-id="element-51">
                <Instagram className="h-5 w-5" data-id="element-52" />
              </a>
            </div>
          </div>

          {/* Product Column */}
          <div data-id="element-53">
            <h3 className="font-semibold mb-4" data-id="element-54">Produto</h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-55">
              <li data-id="element-56">
                <a href="#features" className="hover:text-primary transition-colors" data-id="element-57">
                  Recursos
                </a>
              </li>
              <li data-id="element-58">
                <a href="#pricing" className="hover:text-primary transition-colors" data-id="element-59">
                  Preços
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-61">
                  Integrações
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-63">
                  Novidades
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div data-id="element-64">
            <h3 className="font-semibold mb-4" data-id="element-65">Empresa</h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-66">
              <li data-id="element-67">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-68">
                  Sobre
                </a>
              </li>
              <li data-id="element-69">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-70">
                  Blog
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-72">
                  Carreiras
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-74">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div data-id="element-75">
            <h3 className="font-semibold mb-4" data-id="element-76">Suporte</h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-77">
              <li data-id="element-78">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-79">
                  Documentação
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-81">
                  Central de Ajuda
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-83">
                  Status
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-85">
                  Privacidade
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground" data-id="element-86">
          <p data-id="element-87">
            © {new Date().getFullYear()} GarageFlow ERP. Todos os direitos
            reservados.
          </p>
          <div className="flex items-center gap-4" data-id="element-88">
            <a href="#" className="hover:text-foreground transition-colors" data-id="element-89">
              Termos de Serviço
            </a>
            <a href="#" className="hover:text-foreground transition-colors" data-id="element-90">
              Política de Privacidade
            </a>
          </div>
        </div>
      </div>
    </footer>;
}